import React, { useRef, useState,useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Multiselect from 'multiselect-react-dropdown';
import axios from 'axios';
import { API } from '../../../config/API';
import DatePicker from 'react-datepicker';

function AssignTraining(arg) {
  const [show, setShow] = useState(arg.flag);
  const [seletedDeps, setSeletedDeps] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const userSelected = useRef([]);
  const filteredDep = useRef([]);
  const userRemoved = useRef([]);
  const [expiryDate, setExpiryDate] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1)));
  const [todayDate, setTodayDate] = useState(new Date());
  const [assignByParam, setAssignByParam] = useState('');


  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);
  
  useEffect(() => {
    if (!arg.data) return;

    const ob = arg.data.trainingAssignLog || {};

    const processOptions = (fullOptions) => {
      let temp = [];
      let tempFinal = [];
      let filteredDeps = [];

      if (assignByParam === 'D') {
        if (ob.groupId && ob.groupId.length) temp = ob.groupId;
      } else if (assignByParam === 'P') {
        fullOptions = JSON.parse(localStorage.getItem('ElmaamProjects')) || [];
        if (ob.project && ob.project) temp = ob.project;
      } else if (assignByParam === 'L') {
        fullOptions = JSON.parse(localStorage.getItem('ElmaamLevels')) || [];
        if (ob.level && ob.level) temp = ob.level;
      }

      temp.forEach(element => {
        const result = fullOptions.find(obj => obj.id === element);
        if (result) tempFinal.push(result);
      });

      fullOptions.forEach((dep) => {
        if (!temp.includes(dep['id'])) filteredDeps.push(dep);
      });

      filteredDep.current = filteredDeps;
      setSeletedDeps(tempFinal);
    };

    if (assignByParam === 'D') {
      setLoader(true);
      axios.get(API.getDepartmentData)
        .then((response) => {
          const fullOptions = response.data || [];
          setDepartmentOptions(fullOptions);
          processOptions(fullOptions);
        })
        .catch((error) => {
          console.error('Error fetching departments:', error);
          processOptions([]);
        })
        .finally(() => setLoader(false));
    } else {
      processOptions([]);
    }
  }, [assignByParam, arg.data]);


  const unAssignTraining=()=>{
    setShow(false);
    let selected=[];
    userRemoved.current.forEach((item)=>{
      selected.push(item.id);
    })
    const obj = {
      selected ,
      dueDate : expiryDate.toISOString().split('T')[0],
      type : assignByParam

    }
    arg.unassign(obj);

  }
   
  const assignTraining=()=>{
    setShow(false);
    let selected=[];
   
    userSelected.current.forEach((item)=>{
      selected.push(item.id);
    })
    const obj = {
      selected ,
      dueDate : expiryDate.toISOString().split('T')[0],
      type : assignByParam
    }
    arg.assign(obj);
  }

  const handleDepSelection=(i)=>{
    if(i.length)
    userSelected.current.push(i[i.length-1]);
  }

  const handleRemoveDepSelection=(i)=>{
    if(i.length)
    userRemoved.current.push(i[i.length-1]);
  }

  const labelMap={
    "D" : "Departments",
    "P" : "Projects",
    "L" : "Levels"
  };
  const returnDisplaykey=()=>{
    if(assignByParam === "P" || assignByParam === "L") return "value";
    return "name";
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Assign Training</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {
            !assignByParam && <div className='assign-btn-list'>
            <input type='button' value='By Department' className='btn btn-info push-left' onClick={()=>setAssignByParam('D')}></input>
            <input type='button' value='By Project' className='btn btn-info push-left' onClick={()=>setAssignByParam('P')}></input>
            <input type='button' value='By Level' className='btn btn-info push-left' onClick={()=>setAssignByParam('L')}></input>
          </div> 
          
          }
          <hr></hr>
          {
            assignByParam && <Form>
            <Form.Group
                className="mb-3 mt-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Assigned {labelMap[assignByParam]}</Form.Label>
                 <Multiselect
                displayValue={returnDisplaykey()}
                onKeyPressFn={function noRefCheck(){}}
                onRemove={function noRefCheck(){}}
                onSearch={function noRefCheck(){}}
                onSelect={(i)=> handleRemoveDepSelection(i)}
                options={seletedDeps}
              />
                <input type='button' className='btn btn-danger mt-3' value='UN ASSIGN' onClick={unAssignTraining}></input>
                <hr></hr>
              </Form.Group>
            <Form.Label>Select {labelMap[assignByParam]}</Form.Label>
            <Multiselect
                displayValue={returnDisplaykey()}
                onKeyPressFn={function noRefCheck(){}}
                onRemove={function noRefCheck(){}}
                onSearch={function noRefCheck(){}}
                onSelect={(i)=> handleDepSelection(i)}
                options={filteredDep.current}
              />
               <Form.Group
                className="mb-3 mt-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Due Date</Form.Label>
                <DatePicker dateFormat="yyyy/MM/dd" minDate={todayDate} selected={expiryDate} onChange={(date) =>{ setExpiryDate(date)}} className='form-control'/>
              </Form.Group>
            </Form>
          }
          
        </Modal.Body>
       
        {
          assignByParam &&  <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
          <Button variant="primary" onClick={assignTraining}>
            ASSIGN
          </Button>
        </Modal.Footer>
        
        }
       
      </Modal>
    </>
  );
}

export default AssignTraining;

